export default __webpack_public_path__ + "static/media/img-0707-belgium-full-face.41866d84.png";